module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_1000-1cf7dc2e47e54eaa811b4e67bd0d52d8.png";